import axiosClient from '../api/AxiosConfig';

export const CustomerService = {
  GetCustomer: async (params) => (await axiosClient.get('/customer/cskh', { params })).data,
  ResetCustomer: async (data) => (await axiosClient.post('/customer/cskh', data)).data,
};
